import { render } from "./LegalDocumentModal.vue?vue&type=template&id=4c1b5833&scoped=true"
import script from "./LegalDocumentModal.vue?vue&type=script&lang=js"
export * from "./LegalDocumentModal.vue?vue&type=script&lang=js"

import "./LegalDocumentModal.vue?vue&type=style&index=0&id=4c1b5833&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1b5833"]])

export default __exports__